@if (status$ | async; as status) {
    <div class="sh-progress-status">
        <label class="sh-progress-status__label">{{ status.label.key | translate: status.label.params }}</label>
        <progress
            class="sh-progress--{{ status.tint }} sh-progress-status__progress"
            [value]="asPercentage(status.progress)"
            max="100"
        >
            {{ asPercentage(status.progress) }} %
        </progress>
    </div>
}
